import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler } from 'chart.js'; // Import Filler
import '../styles/transactions.css';

// Register necessary Chart.js components including Filler
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const ChartInfo = ({ transactions }) => {
    // Data processing
    const creditData = transactions.map(transaction => (transaction.type === 'credit' ? transaction.amount : 0));
    const debitData = transactions.map(transaction => (transaction.type === 'debit' ? transaction.amount : 0));
    const labels = transactions.map(() => '');

    // Chart.js data structure
    const data = {
        labels,
        datasets: [
            {
                label: 'Credits',
                data: creditData,
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: true, // Enable filling area below the line
            },
            {
                label: 'Debits',
                data: debitData,
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                fill: true, // Enable filling area below the line
            },
        ],
    };

    // Chart.js options
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                ticks: {
                    display: false, 
                },
                grid: {
                    display: false, 
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Amount',
                },
            },
        },
        plugins: {
            legend: {
                position: 'top',
            },
        },
    };

    return (
        <div className="chart-container">
            <h3>Transaction Overview</h3>
            <div style={{ width: '90%', height: '100%' }}> 
                <Line data={data} options={options} />
            </div>
        </div>
    );
};

export default ChartInfo;
